
import { Layer } from './layer';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import TileGrid from 'ol/tilegrid/TileGrid';
import * as olExtent from 'ol/extent';
import * as olProj from 'ol/proj';

export interface WmsSubLayer {
    name: string;
    enabled: boolean;
}

export class WmsLayer extends Layer {

    declare id: string;
    layerName: string;
    format: string = "png";
    projectionCode: string;
    base: boolean;
    singleTile: boolean;
    minScaleDenominator: number;
    maxScaleDenominator: number;
    sublayers: WmsSubLayer[] = new Array();
    themes: string[] = new Array();
    declare hasLegend: boolean;
    declare url: string;
    queryable: boolean = false;
    // tileLoadFunction;

    constructor(
        id: string,
        label: string,
        type: string,
        url: string,
        projectionCode: string,
        layerName?: string,
        format?: string,
        minScaleDenominator?: number,
        maxScaleDenominator?: number,
        base?: boolean,
        singleTile?: boolean,
        themes?: string[],
        hasLegend?: boolean,
        queryable?: boolean
        // tileLoadFunction?
    ) {

        super(id, label, type);

        if (url) {
            this.url = url
        }

        if (layerName) {
            this.layerName = layerName;

            this.sublayers = this.layerName
                .split(',')
                .map(name => ({
                    name,
                    enabled: true
                }));

        }
        if (projectionCode) {
            this.projectionCode = projectionCode;
        }
        if (format) {
            this.format = format;
        }
        if (base) {
            this.base = base;
        }
        if (singleTile) {
            this.singleTile = singleTile;
        }
        if (minScaleDenominator) {
            this.minScaleDenominator = minScaleDenominator;
        }
        if (maxScaleDenominator) {
            this.maxScaleDenominator = maxScaleDenominator;
        }
        if (themes) {
            this.themes = themes;
        }
        if (hasLegend) {
            this.hasLegend = hasLegend;
        }
        if (queryable) {
            this.queryable = queryable;
        }
        // if (tileLoadFunction) {
        //     this.tileLoadFunction = tileLoadFunction;
        // }
    }


    toOlLayer() {

        let projectionCode = this.projectionCode;//"EPSG:3812";
        /*
        tilegrid: apparently has little/no influence, but when not defined in lamb08 wms (does not matter which tilegrid), quality of tiles are less
        ol doc:
        Base this on the resolutions, tilesize and extent supported by the server. 
        If this is not defined, a default grid will be used: if there is a projection extent, the grid will be based on that; 
        if not, a grid based on a global extent with origin at 0,0 will be used..
        */
        // adapt params according format
        // transparent only for png
        // bgcolor of jpg set in themeswitch
        let params;
        if (this.format.toLowerCase() === 'jpeg' || this.format.toLowerCase() === 'jpg') {
            params = { 'LAYERS': this.layerName, FORMAT: 'image/jpeg', TRANSPARENT: false };//,BGCOLOR: 0xCC60   
        }
        if (this.format.toLowerCase() === 'png') {
            params = { 'LAYERS': this.layerName, FORMAT: 'image/' + this.format, TRANSPARENT: true };
        }        
        let source = new TileWMS({
            crossOrigin: "anonymous",// - ! to avoid crossorigin error in pdf !
            params: params,
            url: this.formatUrl(this.url),
            tileGrid: this.getTileGrid(projectionCode),
            //!
        })

        // when session has expired
        // if (this.tileLoadFunction) {
        //     source.setTileLoadFunction(this.tileLoadFunction);
        // }
        // console.log(params)
        const layerOptions: any = {
            source: source
        };
        if (this.minScaleDenominator !== undefined) {
            layerOptions.minResolution = this.getResolutionForScale(this.minScaleDenominator);
        }
        if (this.maxScaleDenominator !== undefined) {
            layerOptions.maxResolution = this.getResolutionForScale(this.maxScaleDenominator);
        }
        const olLayer = new TileLayer(layerOptions);

        // let olLayer: TileLayer<any> = new TileLayer({
        //     source: source,
        //     minResolution: this.getResolutionForScale(this.minScaleDenominator),
        //     maxResolution: this.getResolutionForScale(this.maxScaleDenominator)
        // });

        olLayer.set('customId', this.id)

        return olLayer;
    }

    private formatUrl(url: string): string {
        let paramsIndex: number = url.indexOf("?");
        return (paramsIndex != -1) ? url.substr(0, paramsIndex) : url;
    }

    private getTileGrid(projectionCode) {
        //todo add tilegridlevels get to calc resolutionsarray for customtilegrid
        // if (!this.tilegridLevels) {
        //     var minlevel, maxlevel;
        //     if (this.minScaleDenominator) {
        //         minlevel = this.getZoomlevelForScale(this.minScaleDenominator, resolutions);
        //     } else {
        //         minlevel = 27;
        //     }
        //     if (this.maxScaleDenominator) {
        //         maxlevel = this.getZoomlevelForScale(this.maxScaleDenominator, resolutions);
        //     } else {
        //         maxlevel = 0;
        //     }
        // }
        // let tilegridLevels = [maxlevel, minlevel];

        let tileGrid;
        switch (projectionCode) {
            case "EPSG:3812":
                {
                    // let resolutions = [
                    //     1058.3354500042335,
                    //     529.1677250021168,
                    //     211.667090000847,
                    //     132.2919312505292,
                    //     66.1459656252646,
                    //     26.458386250105836,
                    //     13.229193125052918,
                    //     6.614596562526459,
                    //     2.6458386250105836,
                    //     1.3229193125052918,
                    //     0.661459656252646,
                    //     0.330729828126323,
                    //     0.1653649140631615
                    // ];
                    let resolutions = [
                        1058.3354500042335,
                        529.1677250021168,
                        211.667090000847,
                        132.2919312505292,
                        66.1459656252646,
                        26.458386250105836,
                        13.22919312505292,
                        6.614596562526459,
                        2.6458386250105836,
                        1.3229193125052918,
                        0.661459656252646,
                        0.330729828126323,
                        0.1653649140631615
                    ];
                    let projection = olProj.get('EPSG:3812');
                    let projectionExtent = projection.getExtent();
                    let origin = [450000, 800000]
                    var size = olExtent.getWidth(projectionExtent) / 256;
                    // for (var z = 0; z < 27; ++z) {
                    //     resolutions[z] = size / Math.pow(2, z);
                    // }
                    tileGrid = new TileGrid({
                        tileSize: 256,
                        origin: origin,
                        resolutions: resolutions,
                        extent: projectionExtent
                    });
                    break;
                }
            case "EPSG:3857":
                {
                    var resolutions = [
                        156543.03392804097,
                        78271.51696402048,
                        39135.75848201024,
                        19567.87924100512,
                        9783.93962050256,
                        4891.96981025128,
                        2445.98490512564,
                        1222.99245256282,
                        611.49622628141,
                        305.748113140705,
                        152.8740565703525,
                        76.43702828517625,
                        38.21851414258813,
                        19.109257071294063,
                        9.554628535647032,
                        4.777314267823516,
                        2.388657133911758,
                        1.194328566955879,
                        0.5971642834779395,
                        0.29858214173896974,
                        0.14929107086948487,
                        0.07464553543474244,
                        0.03732276771737122,
                        0.01866138385868561,
                        0.009330691929342804,
                        0.004665345964671402,
                        0.002332672982335701
                    ];
                    let projection = olProj.get('EPSG:3857');//EPSG:3857
                    let projectionExtent = projection.getExtent();//[-20037508.342789244,-20037508.342789244,20037508.342789244,20037508.342789244];
                    let origin = olExtent.getTopLeft(projectionExtent);//[-20037508.342789244, 20037508.342789244]
                    var size = olExtent.getWidth(projectionExtent) / 256; //156543.03392804097
                    // for (var z = 0; z < 27; ++z) {
                    //     viewResolutions[z] = size / Math.pow(2, z);
                    // }
                    tileGrid = new TileGrid({
                        tileSize: 512,
                        origin: origin,
                        resolutions: resolutions,
                        extent: projectionExtent
                    });
                    break;
                }
            default:
                {
                    tileGrid = undefined;
                }
        }

        return tileGrid;

    }



}
